export const GAME_LEVELS = [
  {
    level: 1,
    rounds: 1,
    chantsPerRound: 11,
    totalChants: 11,
    name: 'प्रथम पूजा',
    nameEn: 'First Prayer',
    color: '#FF9500',
    unlockMessage: 'प्रथम स्तर पूर्ण! जय श्री राम! 🙏',
  },
  {
    level: 2,
    rounds: 2,
    chantsPerRound: 21,
    totalChants: 42,
    name: 'द्वितीय भक्ति',
    nameEn: 'Second Devotion',
    color: '#FF6B00',
    unlockMessage: 'द्वितीय स्तर पूर्ण! हनुमान भक्त! 🔱',
  },
  {
    level: 3,
    rounds: 3,
    chantsPerRound: 51,
    totalChants: 153,
    name: 'तृतीय साधना',
    nameEn: 'Third Sadhana',
    color: '#E65100',
    unlockMessage: 'तृतीय स्तर पूर्ण! राम सेवक! 🌟',
  },
  {
    level: 4,
    rounds: 4,
    chantsPerRound: 101,
    totalChants: 404,
    name: 'चतुर्थ तपस्या',
    nameEn: 'Fourth Tapasya',
    color: '#D4A017',
    unlockMessage: 'चतुर्थ स्तर पूर्ण! संकट मोचन! ⚡',
  },
  {
    level: 5,
    rounds: 5,
    chantsPerRound: 111,
    totalChants: 555,
    name: 'पंचम सिद्धि',
    nameEn: 'Fifth Siddhi',
    color: '#8B0000',
    unlockMessage: 'पंचम स्तर पूर्ण! शक्ति यात्री! ✨',
  },
];

// Cumulative chant totals: [11, 53, 206, 610, 1165]
export const LEVEL_THRESHOLDS = GAME_LEVELS.reduce((acc, lvl, i) => {
  const prev = i === 0 ? 0 : acc[i - 1];
  acc.push(prev + lvl.totalChants);
  return acc;
}, []);

export const MILESTONES = [
  { count: 108,    badge: '108 Ram Badge',   message: '108 राम जप पूरे! पवित्र माला पूर्ण!' },
  { count: 1008,   badge: 'Hanuman Bhakt',   message: '1008 राम जप! हनुमान भक्त!' },
  { count: 5000,   badge: 'Ram Sevak',       message: '5000 राम जप! राम सेवक!' },
  { count: 11000,  badge: 'Sankat Mochan',   message: '11000 राम जप! संकट मोचन!' },
  { count: 21000,  badge: 'Ram Leela',       message: '21000 राम जप! राम लीला!' },
  { count: 51000,  badge: 'Shakti Yatri',    message: '51000 राम जप! सभी शक्ति पीठ धन्य!' },
  { count: 108000, badge: 'Maha Bhakt',      message: 'एक लाख से अधिक! महा भक्त!' },
];

export const PHYSICS = {
  gravity: 0.28,
  jumpForce: -6.5,
  obstacleSpeed: 2.2,
  obstacleGap: 280,
  hanumanSize: 52,
  hitboxReduction: 0.6,
  batchSyncEvery: 10,
  maxTapsPerMin: 120,
  frameRate: 60,
};
